import {Tag, Typography} from "antd";
import React from "react";

const { Text } = Typography;

const ColoredTag = ({name, color, fontSize=12, shadow=true, border=false,
                        width=200, wrap=false})=>{
    return (
        <Tag style={{
            background: `linear-gradient(to right, ${color} 5px, transparent 5px)`,
            width,
            fontSize,
            border: border ? '1px solid #ededed' : 'none'}}
            className={shadow ? 'shadow-sm' : ''}
        >
            <span style={{paddingLeft: '5px', textTransform: 'capitalize', whiteSpace: wrap ? 'nowrap' : ''}}>
                <Text ellipsis={{rows: 1}} style={{fontSize}}>{name}</Text>
            </span>
        </Tag>
    )
}

export default ColoredTag;